import { useQuery } from '@tanstack/react-query';
import orderClient from '../../../api/order';

const useOrderQuery = (orderName: string) => {
  return useQuery({
    queryKey: ['order', orderName],
    queryFn: async () => orderClient.getOrderInfo(orderName),
    enabled: !!orderName,
    retry: false,
  });
};

export default useOrderQuery;
